var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1808 45.2325L54.7802 20.2383",
    stroke: "#8372FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0938 45.2325L24.4943 20.2383",
    stroke: "#F7B500",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8915 45.2209C53.7776 45.2209 55.4913 45.994 56.7341 47.2368C57.9769 48.4796 58.75 50.1934 58.75 52.0795C58.75 53.9656 57.9769 55.6793 56.7341 56.9221C55.4913 58.1649 53.7776 58.938 51.8915 58.938C50.0054 58.938 48.2916 58.1649 47.0488 56.9221C45.806 55.6793 45.0329 53.9656 45.0329 52.0795C45.0329 50.1934 45.806 48.4796 47.0488 47.2368C48.2916 45.994 50.0054 45.2209 51.8915 45.2209Z",
    stroke: "#FA6400",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1085 45.2209C28.9946 45.2209 30.7084 45.994 31.9512 47.2368C33.194 48.4796 33.9671 50.1934 33.9671 52.0795C33.9671 53.9656 33.194 55.6793 31.9512 56.9221C30.7084 58.1649 28.9946 58.938 27.1085 58.938C25.2224 58.938 23.5087 58.1649 22.2659 56.9221C21.0231 55.6793 20.25 53.9656 20.25 52.0795C20.25 50.1934 21.0231 48.4796 22.2659 47.2368C23.5087 45.994 25.2224 45.2209 27.1085 45.2209Z",
    stroke: "#8372FF",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCut);
export default __webpack_public_path__ + "static/media/cut.e043f78c.svg";
export { ForwardRef as ReactComponent };